import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BaseService} from 'src/app/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class ProductsDistributorsService extends BaseService {

  listDistributor(query?: any): Observable<any> {
    const httpOptions = {
      params: query
    };
    return this.get<any>('product/distributor/list', httpOptions);
  }

  detailDistributor(query?: any): Observable<any> {
    const httpOptions = {
      params: query
    };
    return this.get<any>('product/distributor/detail', httpOptions);
  }

  addDistributor(id, body): Observable<any> {
    return this.post<any>(`product/distributor?product_id=${id}`, body);
  }

  searchDistributor(query?: any): Observable<any> {
    const httpOptions = {
      params: query
    };
    return this.get<any>('product/distributor/search', httpOptions);
  }

  addIdDistributor(body): Observable<any> {
    return this.post<any>(`product/distributor/assign`, body);
  }

  editDistributor(body): Observable<any> {
    return this.post<any>(`distributor/product/update`, body);
  }

  deleteDistributor(body): Observable<any> {
    return this.delete<any>(`product/distributor`, body);
  }

  exportExcel(query?: any) {
    const httpOptions = {
      params: query,
      responseType: 'blob'
    };
    return this.get<any>(`/product/distributor/export`, httpOptions);
  }

}
